import { CommonModule } from "@angular/common";
import { UiModule } from "./../ui/ui.module";
import { CoreModule } from "@webapp/core/core.module";
import { NgModule } from "@angular/core";
import { AccountPickerComponent } from "./components/account-picker/account-picker.component";
import { UiModalService } from "@webapp/ui/modal/services/modal.service";

@NgModule({
  declarations: [AccountPickerComponent],
  exports: [AccountPickerComponent],
  imports: [CoreModule, UiModule, CommonModule],
  providers: [UiModalService],
})
export class AccountsModule {}
